import path from 'path'
import React, { Component } from 'react'
import { Button, Drawer, Skeleton } from 'antd'
import { PrinterOutlined } from '@ant-design/icons'
import { PDFDownloadLink } from '@react-pdf/renderer'
import QRCode from 'qrcode.react'
import IKiosk from '../../../../../interfaces/IKiosk'
import Config from '../../../../../config'
import KioskQrCodePrint from './Print'

type KioskDetailProps = {
  kiosk: IKiosk

  onClose: () => void
}

export default class KioskDetail extends Component<KioskDetailProps> {

  state = {
    visible: false,
    qrCodeDataUri: ''
  }

  componentDidMount() {
    const { kiosk } = this.props

    this.setState({
      visible: !!kiosk
    }, () => {
      this.getQrCodeBase64()
    })
  }

  private getQrCodeBase64 = () => {
    const { kiosk } = this.props

    const doc = document.getElementById(`kiosk-qr-code-${kiosk.uuid}`)
    const qrCodeCanvas = doc?.querySelector('canvas')
    const qrCodeDataUri = qrCodeCanvas?.toDataURL('image/jpg', 0.3)

    this.setState({
      qrCodeDataUri: qrCodeDataUri || ''
    })
  }

  private handleClose = () => {
    this.setState({
      visible: false
    }, () => {
      setTimeout(() => {
        this.props.onClose()
      }, 500)
    })
  }

  render() {
    const { kiosk } = this.props
    const { visible, qrCodeDataUri } = this.state

    const title = kiosk.name || 'Unnamed'
    const qrCodeValue = path.join(Config.kioskBase, `self-check-in?fingerprint=${kiosk.fingerprint}&uuid=${kiosk.uuid}`)

    return (
      <Drawer
        title={`${title} - QR Code`}
        width={320}
        closable={false}
        visible={visible}
        onClose={this.handleClose}
      >
        <div id={`kiosk-qr-code-${kiosk.uuid}`}>
          <QRCode size={270} value={qrCodeValue} />
        </div>

        {
          qrCodeDataUri.length > 0 ? (
            <PDFDownloadLink document={<KioskQrCodePrint name={title} content={qrCodeDataUri} />} fileName={kiosk.uuid}>
              {({ loading, url }) => {
                if (loading) return <Skeleton />

                return (
                  <Button
                    type="primary"
                    icon={<PrinterOutlined />}
                    onClick={() => window.open(url || '', '_blank')}
                    block
                  >
                    Print QR Code
                  </Button>
                )
              }}
            </PDFDownloadLink>
          ) : null
        }
      </Drawer>
    )
  }
}
